import React from 'react'
import { Modal, Button } from 'react-bootstrap';

const SubscriptionLogsModal = ({ show, handleClose, subscriptionLogs }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Subscription Logs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="table-responsive">
                    <table className="table table-sm table-hover table-nowrap card-table">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Plan Name</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col">Total Tickets</th>
                                <th scope="col">Used Tickets</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptionLogs.length > 0 ? (
                                subscriptionLogs.map((log, index) => (
                                    <tr key={log.id}>
                                        <td>{index + 1}</td>
                                        <td>{log.plan?.name || 'N/A'}</td>
                                        <td>{log.start_date}</td>
                                        <td>{log.end_date}</td>
                                        <td>{log.plan?.no_of_tickets || 'N/A'}</td>
                                        <td>{log.usedTicketsCount || 0}</td>
                                        <td>
                                            <span className={`badge ${log.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                                                {log.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className='text-center'>No Subscription Logs Available</td>
                                </tr>
                            )
                            }
                        </tbody>
                    </table>
                </div>
                <div className="modal-footer">
                    <Button variant="danger" size='sm' onClick={handleClose}>
                        Cancel
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default SubscriptionLogsModal